import {Permission} from 'src/app/models/principal/permission';
import {Authority} from 'src/app/models/principal/authority';

/**
 * Map with permission and array with roles which has the permission to execute given operation.
 */
export const PERMISSIONS_MAP = {
  [Permission.ADD_TENANT]: [Authority.MANAGEMENT_OPERATOR],
  [Permission.ADD_ROUTE]: [Authority.MANAGEMENT_OPERATOR],
  [Permission.ADD_COMPONENT]: [Authority.MANAGEMENT_OPERATOR],
  [Permission.ADD_SUBSCRIPTION]: [Authority.MANAGEMENT_OPERATOR],
  [Permission.DEPLOY_INGRESS_SERVICES]: [Authority.MANAGEMENT_OPERATOR],
  [Permission.ADD_SOLUTION]: [Authority.MANAGEMENT_OPERATOR],
  [Permission.ADD_SOLUTION_VERSION]: [Authority.MANAGEMENT_OPERATOR],
  [Permission.ADD_LOB]: [Authority.MANAGEMENT_OPERATOR],
  [Permission.EDIT_SOLUTION]: [Authority.MANAGEMENT_OPERATOR],
  [Permission.DELETE_SOLUTION]: [Authority.MANAGEMENT_OPERATOR],
  [Permission.EDIT_LOB]: [Authority.MANAGEMENT_OPERATOR],
  [Permission.DELETE_LOB]: [Authority.MANAGEMENT_OPERATOR],
  [Permission.EDIT_SOLUTION_VERSION]: [Authority.MANAGEMENT_OPERATOR],
  [Permission.DELETE_SOLUTION_VERSION]: [Authority.MANAGEMENT_OPERATOR],
  [Permission.DR_ACTION]: [Authority.MANAGEMENT_DR_OPERATOR],
  [Permission.UPDATE_VERSION]: [Authority.MANAGEMENT_OPERATOR],
  [Permission.EXTERNAL_PACKAGE_UPDATE]: [Authority.MANAGEMENT_OPERATOR],
  [Permission.EDIT_EMAIL]: [Authority.MANAGEMENT_OPERATOR],
  [Permission.CREATE_SERVICE_DEFINITION]: [Authority.MANAGEMENT_OPERATOR],
  [Permission.ADD_SSH_KEY]: [Authority.MANAGEMENT_OPERATOR]
};
